import { render, staticRenderFns } from "./NominationDisqualified.vue?vue&type=template&id=39e5dcce&scoped=true"
import script from "./NominationDisqualified.vue?vue&type=script&lang=js"
export * from "./NominationDisqualified.vue?vue&type=script&lang=js"
import style0 from "./NominationDisqualified.vue?vue&type=style&index=0&id=39e5dcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5dcce",
  null
  
)

export default component.exports